import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Container, Form, FormControl, Image, InputGroup, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import bill from '../../../assets/images/logo6-small.png'
import LoadingSpinner from "../../shared/components/LoadingSpinner";
import { fetchAccountDetails, otpVerify, register, resetAuth, resetError, verifyAccountDetails, verifyUser } from "../store/authSlice";
import { insertData, insertUser } from "../../myaccount/store/userProfileSlice";
import { setUser } from "../../shared/store/sharedSlice";
import { toast, ToastContainer } from "react-toastify";



const Login = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const auth = useSelector((state) => state?.auth);

    const { accessToken, isLoggedIn, verifyAccountStatus, authCodeStatus, authenticationDetails, tenants, error,otpErrorMessage,loading,verifyAccountError } = useSelector((state) => state?.auth);

    const otpStatus = auth?.otpStatus;
    const isOtpVerify = auth?.isOtpVerify;


    const [getOtp, setGetOtp] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState("");
    const otpInputRef = useRef(null);
    const [phoneError, setPhoneError] = useState("");
    const [formData, setFormData] = useState({ phone: "" });
    const [verify, setVerify] = useState(false);
    const [timer, setTimer] = useState(0);
    const [canResend, setCanResend] = useState(false);



    const handlePhoneInputChange = (event) => {
        const inputValue = event.target.value.replace(/\D/g, ""); // Replace any non-digit character with an empty string
        setFormData({ ...formData, phone: inputValue });
        setPhoneError("");
    };


    const handleGetOtp = () => {
        if (!formData.phone || formData.phone.length < 10) {
            setPhoneError("Please enter the phone number");
            return;
        }
        setTimer(30);
        setGetOtp(true);
        setVerify(true);
        setCanResend(false);
        if (otpInputRef.current) {
            otpInputRef.current.focus();
        }
        dispatch(register(formData));

    };

    const handleVerify = () => {
        if (!otp || otp.length < 6) {
            setOtpError("Please enter OTP");
        } else {
            setVerify(false);

            dispatch(otpVerify({ phone: formData.phone, otp: otp }));
        }
    };

    const handleOtpChange = (e) => {

        setOtp(e.target.value);
        // setOtpError("");
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            handleGetOtp();
        }
    };

    const handleVerifyKeyPress = (event) => {
        if (otp.length > 5 && event.key === "Enter") {
            handleVerify();
        }
    };

    const handleKeyDown = (e) => {

        if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
            e.preventDefault();
        }

        if (otp.length > 5 && e.key === 'Enter') {
            handleVerify();
        }
    };

    useEffect(() => {
        if (error) {
            dispatch(resetError())
            toast.error("You have no busineses. please create one business")
            setTimer(0);
            setCanResend(false);
            setGetOtp(false);
            setOtp("")
            setVerify(false)
        }
    }, [error])

    useEffect(() => {
        if (isOtpVerify == true) {
            const userData = {
                id: auth?.user?.id,
                name: auth?.user?.name,
                phone: auth?.user?.phone,
                currentTenant: '',
                email: auth?.user?.email == "null" ? "" : auth?.user?.email,
                flavor: '',
            };
            if (tenants.length > 0) {
                if (auth?.user?.authenticate_code == null) {
                    dispatch(fetchAccountDetails({ id: auth?.user?.id }));
                } else {
                    dispatch(verifyAccountDetails({ code: auth?.user?.authenticate_code }));
                    dispatch(verifyUser(userData));
                }
            } else {
                dispatch(resetAuth())
                toast.error("You have no busineses. please create one business")
                setTimer(0);
                setCanResend(false);
                setGetOtp(false);
                setOtp("")
                setVerify(false)
            }
        }
    }, [isOtpVerify]);


    useEffect(() => {
        if (authCodeStatus) {
            const userData = {
                id: auth?.user?.id,
                name: auth?.user?.name,
                phone: auth?.user?.phone,
                currentTenant: '',
                email: auth?.user?.email == "null" ? "" : auth?.user?.email,
                flavor: '',
            };
            dispatch(verifyAccountDetails({ code: authenticationDetails?.code }));
            dispatch(verifyUser(userData));
        }
    }, [authCodeStatus])


  



    useEffect(() => {
        if (otpStatus == "sent" && timer) {
            dispatch(resetError())
            toast.success("OTP sent successfully")
            setTimer(120);
            setCanResend(false);
        } else if (otpStatus == "verified" && timer) {
            dispatch(resetError())
            setTimer(0);
            setCanResend(false);
        } else if (otpStatus == "error" && timer) {
            dispatch(resetError())
            toast.error(otpErrorMessage)
            setTimer(0);
            setCanResend(false);
            setGetOtp(false);
            setOtp("")
            setVerify(false)

        }
    }, [otpStatus]);

    useEffect(() => {

        if (timer > 0) {
            const countdown = setTimeout(() => setTimer(timer - 1), 1000);
            return () => clearTimeout(countdown);
        } else if (timer === 0 && getOtp) {
            setCanResend(true);

        }
    }, [timer, getOtp]);


    useEffect(() => {
        if (verifyAccountStatus && tenants?.length > 0) {
            dispatch(resetAuth())
            setTimer(0);
            setCanResend(false);
            setGetOtp(false);
            setOtp("")
            toast.success("Login successfully")
            navigate("/business")
        }else{
            dispatch(resetAuth())
        }
    }, [verifyAccountStatus])


    useEffect(()=>{
        if(verifyAccountError){
            dispatch(resetAuth())
            setTimer(0);
            setCanResend(false);
            setGetOtp(false);
            setOtp("")
        }
            },[verifyAccountError])




    return (
        <>
            <ToastContainer />
            <Container fluid className="bg-white"
                style={{
                    height: "calc(100vh - 10px)",
                    overflowX: "hidden",
                    overflowY: "auto",
                    backgroundRepeat: "repeat",
                    backgroundSize: "auto",
                }}>
                <div className="d-flex justify-content-center align-items-center"
                    style={{ height: 'calc(100vh - 100px)' }}>

                    <Card className="w-100 w-md-75 w-lg-50 border"
                        style={{
                            maxWidth: '450px',
                            //boxShadow: "1px 1px 2px hsl(0deg 0% 0% / 0.38)",
                        }}>
                        <Card.Header>
                            <Col className="d-flex justify-content-center">
                                <Image src={bill} alt="Billplus+" style={{ height: "75px" }} />
                            </Col>
                        </Card.Header>
                        <Card.Body className="">
                            <Row>
                                <Col xs={12}>
                                    <Form.Label className="d-block " style={{ fontSize: '14px' }}>
                                        Enter your mobile number
                                    </Form.Label>
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col xs={12} className="">
                                    <InputGroup className="mb-3 w-100">
                                        <InputGroup.Text id="phone-prefix">+91</InputGroup.Text>
                                        <FormControl
                                            type="text"
                                            name="phone"
                                            pattern="[0-9]*"
                                            maxLength={10}
                                            placeholder="Please enter your mobile number"
                                            onChange={handlePhoneInputChange}
                                            onKeyPress={handleKeyPress}
                                            value={formData.phone}
                                            autoFocus={true}
                                        />
                                    </InputGroup>
                                </Col>
                                {phoneError && <div className="text-danger text-center">{phoneError}</div>}
                            </Row>

                            {!getOtp && (
                                <Row className="mt-3">
                                    <Col xs={12} className="">
                                        <Button className="" onClick={handleGetOtp}>
                                            Get OTP
                                        </Button>
                                    </Col>
                                </Row>
                            )}

                            {getOtp && (
                                <Row className="mt-3">
                                    <Col xs={12}>
                                        <Form.Label className="d-block " style={{ fontSize: '14px' }}>
                                            Enter OTP
                                        </Form.Label>
                                        <FormControl
                                            type="text"
                                            name="otp"
                                            pattern="[0-9]*"
                                            minLength={6}
                                            maxLength={6}
                                            ref={otpInputRef}
                                            value={otp}
                                            onChange={(e) => handleOtpChange(e)}
                                            autoFocus={true}
                                            onKeyDown={handleKeyDown}
                                            onKeyPress={handleVerifyKeyPress}
                                            className=""
                                        />
                                        {otpError && <div className="text-danger ">{otpError}</div>}
                                    </Col>
                                </Row>
                            )}

                            {verify && (
                                <Row className="mt-3">
                                    <Col xs={12} className="d-flex align-items-center">
                                        <Button className="" onClick={handleVerify}>
                                            Verify
                                        </Button>
                                        {canResend && (
                                            <Button variant="link" onClick={handleGetOtp} className="mt-2">
                                                Resend OTP
                                            </Button>
                                        )}
                                        {!canResend && (
                                            <Form.Label className="text-success mt-2 mx-2">
                                                OTP sent : {timer} Sec
                                            </Form.Label>
                                        )}
                                    </Col>
                                </Row>
                            )}
                            {loading && <LoadingSpinner />}
                        </Card.Body>
                    </Card>
                </div>


            </Container>

        </>
    );
}

export default Login;